import { useTranslations } from '@vocab/react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTE_TEST_PAGE } from 'src/app/constants/routes';
import { PageViewTracker } from 'src/app/dataAnalytics/components/PageViewTracker';
import { IntercomConfiguration } from 'src/app/intercom';
import { getLocalisedFlowRoutes, getLocalisedRootRoutes } from 'src/app/routes';
import { routeNameToContainer } from 'src/app/routes/routeNameToContainer';
import { isDev } from 'src/app/utils/environment';
import TestPage from 'src/app/views/pages/Test';
import { SeoTitle } from 'src/app/views/shared/SeoTitle';

import type { EmployerSiteName } from '../../../../types/app';
import { usePageId } from '../../hooks/usePageId';
import translations from '../.vocab';

interface Props {
  site: EmployerSiteName;
}

const RootContainer = ({ site }: Props) => {
  const { t } = useTranslations(translations);
  usePageId();

  const rootRoutes = getLocalisedRootRoutes(site);
  return (
    <>
      <SeoTitle title={t('root-container-seo-title')} />
      <PageViewTracker />
      <IntercomConfiguration site={site} />
      <Switch>
        {rootRoutes.map(({ name, route }) => {
          const CurrentRouteContainer = routeNameToContainer[name];
          const localisedFlowRoutes = getLocalisedFlowRoutes(site, name);

          return (
            <Route
              key={name}
              path={route}
              render={() => (
                <CurrentRouteContainer routes={localisedFlowRoutes} />
              )}
            />
          );
        })}
        {isDev() && (
          <Route path={ROUTE_TEST_PAGE} component={TestPage} exact={true} />
        )}
      </Switch>
    </>
  );
};

export default RootContainer;
